export const ArrowDropdown = () => (
  <g>
    <path
      d='M8.71011 11.71L11.3001 14.3C11.4875 14.4863 11.7409 14.5908 12.0051 14.5908C12.2693 14.5908 12.5228 14.4863 12.7101 14.3L15.3001 11.71C15.4411 11.5701 15.5373 11.3914 15.5764 11.1967C15.6155 11.002 15.5957 10.8 15.5195 10.6165C15.4433 10.4331 15.3142 10.2765 15.1487 10.1667C14.9832 10.0569 14.7887 9.99886 14.5901 10H9.41011C9.21234 10.0008 9.01926 10.0603 8.85527 10.1709C8.69129 10.2814 8.56377 10.4381 8.48885 10.6212C8.41392 10.8042 8.39495 11.0053 8.43434 11.1991C8.47372 11.393 8.56969 11.5707 8.71011 11.71Z'
      fill='currentColor'
    />
  </g>
)
